import { gql } from "@apollo/client";

export const SEND_CONTACT = gql`
    mutation SendContact($input: SendContactInput!) {
        sendContact(input: $input)
    }
`;
